import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "../../styles/newpopup.css";
import { getImageUrl } from "utils/helper";

const CustomerProductDetailsPopup = ({ product, onClose }) => {
  const images = [product.imageUrl];

  return (
    <AnimatePresence>
      <motion.div
        className="product_popup_cart_overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        onClick={onClose}
      >
        {/* Close Button Outside the Card */}
        <motion.div
          className="product_popup_cart_close_icon"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          transition={{ duration: 0.4, delay: 0.2 }}
          onClick={onClose}
        >
          &times;
        </motion.div>

        {/* Popup Card */}
        <motion.div
          className="product_popup_cart_container"
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: "20%", opacity: 1 }}
          exit={{ y: "100%", opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Image Slider */}
          <div className="product_popup_cart_image_slider">
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={10}
              slidesPerView={1}
              pagination={{ clickable: true }}
              autoplay={{ delay: 1000, disableOnInteraction: false }}
              loop={true}
            >
              {images.map((image, index) => (
                <SwiperSlide key={index}>
                  <img
                    key={image}
                    src={getImageUrl(image)}
                    alt={product.title}
                    className="product_popup_cart_slider_image"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Product Details */}
          <div className="product_popup_cart_details">
          <h2 className="product_popup_cart_name">{product.title}</h2>
          
          <b>Details:</b>
          <p>{product.description}</p>
            <div className="product_popup_cart_quantity_control">
              <motion.button
                className="product_popup_cart_add_to_cart_btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={
                  () => {}
                  /*   handleAddToCart(
                    product,
                    product.defaultShop || product.shopPrices[0]?.shopname
                  ) */
                }
              >
                Add to Cart
              </motion.button>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default CustomerProductDetailsPopup;
